<template>
  <div
    v-if="visible && hasContent"
    class="visual-disclaimer"
    @click="close"
    role="dialog"
    aria-label="Visual disclaimer"
  >
    <img :src="imageUrl('img/marzipano/minimap-close.svg')" class="close-btn" alt="close" />
    <div class="content" v-html="html"></div>
  </div>
</template>

<script>
import {imageUrl} from '@/utils/urls';

export default {
  name: 'VisualDisclaimer',
  props: {
    html: {
      type: String,
      default: '',
    },
    open: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      visible: this.open,
    };
  },
  computed: {
    imageUrl() {
      return imageUrl;
    },
    hasContent() {
      return !!(this.html && this.html.trim());
    },
  },
  watch: {
    open(val) {
      this.visible = val;
    },
  },
  methods: {
    close() {
      this.visible = false;
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.visual-disclaimer {
  position: relative;
  width: 470px;
  max-width: calc(100vw - 24px);
  background: rgba(0, 0, 0, 0.85);
  color: #fff;
  border-radius: 6px;
  padding: 10px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.35);
  cursor: pointer;
}

.visual-disclaimer .content ::v-deep a { color: #9ad1ff; text-decoration: underline; }
.visual-disclaimer .content ::v-deep p { margin: 0 0 8px; }

.close-btn {
  position: absolute;
  right: -10px;
  top: -10px;
  width: 26px;
  height: 26px;
  opacity: 0.9;
}
</style>
